import api from './api'

// ⚠️ ENDPOINT REAL DE BIND - Backend hace proxy
// El backend llama a: POST https://sandbox.bind.com.ar/v1/banks/:bank_id/accounts/:account_id/:view_id/transaction-request-types/TRANSFER/transaction-requests
// Path params: bank_id=322, account_id=XX-X-XXXX-X-X (cuenta origen), view_id=owner
// Body: { origin_id, origin_account_id, to: {cbu, label, cuit, account_id}, value: {currency, amount}, description, concept, emails }
export async function executeTransfer(transferData) {
  // Sigue enviando source_portal 'zento' hasta que Flash tenga endpoints propios.
  // El backend lo usa para etiquetar el webhook saliente al middleware.
  const response = await api.post('/transfer', { ...transferData, source_portal: 'zento' })
  return response.data
}

/**
 * Ejecutar transferencias masivas (solo CREDENCIAL)
 * Endpoint: POST /processBatch/v1/sendTransfersByCVU
 * @param {Array} transfers - Array de objetos con: from_cvu, to_cvu, amount, concept, description
 */
export async function executeBulkTransfer(transfers) {
  // Sigue enviando source_portal 'zento' hasta que Flash tenga endpoints propios.
  const response = await api.post('/transfer/bulk', { transfers, source_portal: 'zento' })
  return response.data
}

/**
 * Genera origin_id único (máximo 15 caracteres)
 * Requerido por Bind API para identificar la transacción
 */
export function generateOriginId() {
  const timestamp = Date.now().toString()
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
  const originId = `origin_${timestamp}_${random}`
  return originId.substring(0, 15)
}

/**
 * Consultar información de transferencia COELSA (CVU/CBU - interbancaria)
 * Solo CREDENCIAL
 * IMPORTANTE: Usar pos_date y pos_time del movimiento, NO timestamp
 * @param {string} posDate - Fecha en formato YYYYMMDD (ej: "20251231")
 * @param {string} posTime - Hora en formato HHMMSS (ej: "124236")
 * @param {string} authorizationCode - Código de autorización
 * @param {string} amount - Monto de la transacción
 */
export async function getTransferInfoCoelsa(posDate, posTime, authorizationCode, amount) {
  console.log('🔵 ACA ESTA HECHO LO DEL POSDATE BRAI')
  console.log('   pos_date:', posDate)
  console.log('   pos_time:', posTime)
  console.log('   authorization_code:', authorizationCode)
  console.log('   amount:', amount)
  
  const response = await api.post('/transfer/info/coelsa', {
    pos_date: posDate,
    pos_time: posTime,
    authorization_code: authorizationCode,
    amount: amount
  })
  return response.data
}

/**
 * Consultar información de transferencia C2C (Card-to-Card - interna)
 * Solo CREDENCIAL
 * @param {string} transactionDatetime - Fecha exacta "YYYY-MM-DD HH:MM:SS"
 * @param {string} authorizationCode - Código de autorización
 * @param {string} account - Cuenta origen/destino (opcional)
 * @param {string} cardAlias - Alias de tarjeta (opcional)
 */
export async function getTransferInfoC2C(transactionDatetime, authorizationCode, account = '', cardAlias = '') {
  const response = await api.post('/transfer/info/c2c', {
    transaction_datetime: transactionDatetime,
    authorization_code: authorizationCode,
    account: account,
    card_alias: cardAlias
  })
  return response.data
}

/**
 * Consultar estado de un lote de transferencias
 * Solo CREDENCIAL
 * @param {string} processId - UUID del proceso a consultar
 */
export async function getBatchStatus(processId) {
  const response = await api.post('/transfer/batch-status', {
    process_id: processId
  })
  return response.data
}

